export function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

export function throttle(fn, delay) {
  let lastCall = 0;
  return (...args) => {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    // eslint-disable-next-line consistent-return
    return fn(...args);
  };
}

export async function fetchSearchSuggestion(q) {
  // ref: https://shopify.dev/docs/api/ajax/reference/predictive-search#get-locale-search-suggest-json
  // eslint-disable-next-line max-len
  const SUGGESTION_URL = `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(q)}&resources[options][unavailable_products]=hide&resources[options][fields]=title,tag,product_type,variants.title,variants.sku`;
  // eslint-disable-next-line no-return-await
  return await (await fetch(SUGGESTION_URL)).json();
}

export function waitForElm(selector) {
  return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        return;
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });  
}
